import React from "react";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import { styled } from "@mui/material/styles";
import Cookies from "universal-cookie";
import { LifeSafer } from "../_helpers/BrandConstants";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { brandColors } from "../_components/brandedComponent/BrandedColors";
import { useLocation, useNavigate } from "react-router-dom";

const WelcomeBack = ({phoneNumber}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const cookies = new Cookies();
  const brand = cookies.get("lsEnrollmentReferral") || LifeSafer;
  const location = useLocation();
  const { enrolleeData, step, story } = location.state || {};
  const ButtonUpdate = styled(Button)(() => ({
    backgroundColor: "#fff",
    color: `${brandColors[brand].primary}`,
    fontWeight: 600,
  }));
  const handleContinueClick = () => {
    if (!story) {
      navigate("/pick-a-story");
    } else {
      if (story || step || enrolleeData) {
        return navigate(`/story/${story}`, {
          state: {
            enrolleeData,
            step: enrolleeData?.step,
            story: enrolleeData?.story,
          },
        });
      }
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexGrow: 1,
        alignItems: "center",
        justifyContent: "center",
        marginTop: "100px",
      }}
    >
      <Paper
        elevation={2}
        sx={{
          p: 2,
          textAlign: "left",
          minHeight: 300,
          maxHeight: 330,
          width: 320,
          mx: "auto",
          overflow: "auto",
        }}
      >
        <Grid container direction="column">
          <Grid sx={{ mt: 0.5, textAlign: "center" }}>
            <VolunteerActivismIcon
              sx={{
                color: "#1c355e",
                width: 200,
                height: 200,
                opacity: 0.1,
              }}
            />
            <Typography
              sx={{
                textAlign: "center",
                zIndex: 10,
                fontSize: 20,
                mt: -24,
              }}
            >
              {t("steps.welcomeBack", {
                FirstName: enrolleeData?.firstName
                  ? enrolleeData?.firstName
                  : "",
              })}
            </Typography>
          </Grid>

          <Grid
            container
            sx={{
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
              width: "100%",
            }}
            mt={4}
          >
            <Grid>
              <Button
                variant="contained"
                onClick={handleContinueClick}
                color="primary"
                size="medium"
              >
                {t("steps.continue")}
              </Button>
            </Grid>
            <Grid>
              <ButtonUpdate
                variant="contained"
                component="a"
                // href={`tel:${t(`brandInfo.brandPhone.${brand}`).replace(
                //   /\D/g,
                //   ""
                // )}`}
                href={`tel:${phoneNumber}`}
              >
                {/* {t(`brandInfo.brandPhone.${brand}`)} */}
                {phoneNumber}
              </ButtonUpdate>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
};

WelcomeBack.propTypes = {
  formLeadInfo: PropTypes.object.isRequired,
  loadStates: PropTypes.func.isRequired,
  statesList: PropTypes.array.isRequired,
  onChange: PropTypes.func,
  saveEnrollee: PropTypes.func,
  enrolleeOptIn: PropTypes.func,
  enrolleeUpdate: PropTypes.func,
  enrollee: PropTypes.object.isRequired,
  loadVehicle: PropTypes.func,
  vehicleList: PropTypes.array,
  phoneNumber: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    statesList: state.statesList,
    enrollee: state.enrollee,
    vehicleList: state.vehicle,
  };
}

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(WelcomeBack);
